import Layout from '../components/Layout'
import SectionHeader from '../components/SectionHeader'
import Skills from '../components/Skills'

function About() {
  return (
    <Layout>
      <div className="pt-40 pb-32 md:pb-0 h-full">
        <SectionHeader
          subtitle="ABOUT ME"
          title="Just a guy who loves <br /> making cool stuff."
        />

        <div className="mt-10 grid grid-cols-1 lg:grid-cols-2 gap-20">
          <div className="space-y-8 text-gray-600">
            <p className="text-lg">
              Hey! I'm <b>Niklavs</b>, a developer from Riga who's passionate
              about creating interactive experiences. I love the challenge of
              turning creative ideas into reality through code, whether it's
              building games, web applications, or exploring new technologies.
            </p>

            <p>
              My journey began with a simple fascination: the idea that by
              writing lines of text, you can create something from absolutely
              nothing. This magical ability to transform abstract ideas into
              real, interactive experiences captivated me. What started as
              curiosity about how games are made evolved into a passion for both
              game development and web technologies, where each project feels
              like bringing a new world to life.
            </p>

            <p>
              When I'm not coding, you can find me exploring new game
              development techniques, experimenting with different technologies,
              or thinking about my next creative project. I believe in
              continuous learning and am always excited to take on new
              challenges that push my creative and technical boundaries.
            </p>
          </div>

          <div className="">
            <Skills />
          </div>
        </div>
      </div>
    </Layout>
  )
}

export default About
